import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

const CreateDesignations = ({ isOpen, onRequestClose, companyId, companycode, designationId }) => {
  const navigate = useNavigate();
  const url = designationId ? `/api/designation/update` : "/api/designation/create";
  const [designation, setDesignation] = useState("");
  const [admin, setAdmin] = useState({
    companyId: companyId,
    designation: "",
    id: designationId ? designationId : null
  });
  const [loading, setLoading] = useState(false);
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    const fetchDesignation = async () => {
      try {
        const designationRes = await axios.get(`/api/designation/${designationId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (designationRes.data) {
          setDesignation(designationRes.data);
          setAdmin({
            companyId: companyId,
            designation: designationRes.data.designation,
            id: designationRes.data.id
          });
        }
      } catch (error) {
        console.error('Error fetching designation:', error);
      }
    };

    if (designationId && token) {
      fetchDesignation();
    }
  }, [designationId, companyId, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (admin.designation) {
      try {
        await axios.post(url, admin, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setLoading(false);
        onRequestClose();
        setAdmin({ companyId: companyId, designation: "", id: null });
        toast.success(designation ? "Designation updated successfully" : "Designation added successfully");
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    } else {
      setLoading(false);
      toast.error("Please fill out all required fields.");
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setAdmin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">work</i>
          {designation ? "Update Designation" : "Add Designation"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {companycode && (
            <div className="mb-3">
              <label htmlFor="companycode" className="form-label small fw-semibold">Company Code</label>
              <input
                className="form-control bg-light"
                id="companycode"
                type="text"
                value={companycode}
                readOnly
              />
            </div>
          )}

          <div className="mb-4">
            <label htmlFor="designation" className="form-label small fw-semibold">
              Designation Title <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="designation"
              type="text"
              placeholder="e.g. Senior Manager / Software Engineer"
              value={admin.designation}
              onChange={rhandle}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>{designation ? "edit" : "work"}</i>
              {designation ? "Update Designation" : "Save Designation"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateDesignations;
